import { Form } from "react-bootstrap";

const Input = ({ label, name, value, setter, type = 'text', required, disabled = false }) => {
    return ( 
        <>
            <Form.Label className="mb-1">{ label }</Form.Label>
            <Form.Control 
                type={type}
                name={ name } 
                value={ value }
                onChange={ (e) => setter(e.target.value) }
                required={required ? true : false}
                disabled={disabled}
                />
        </>
     );
}
 
export default Input;